import * as React from "react";
import Svg, { Path } from "react-native-svg";

function LocationImage(props) {
  return (
    <Svg
      width="120"
      height="83"
      viewBox="0 0 120 83"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M21.1731 63.6055L14.8284 59.8969L18.3114 57.8447L24.6561 61.568L21.1731 63.6055Z"
        fill="#57A2FF"
      />
      <Path
        d="M31.2175 69.4835L24.8584 65.7748L28.3559 63.7373L34.7006 67.4459L31.2175 69.4835Z"
        fill="#57A2FF"
      />
      <Path
        d="M41.2478 75.376L34.9031 71.6528L38.4006 69.6152L44.7453 73.3238L41.2478 75.376Z"
        fill="#57A2FF"
      />
      <Path
        d="M52.6942 81.0639C51.1998 80.6672 49.7475 80.1222 48.3584 79.4368L47.3901 78.9384L46.5663 78.4547L44.991 77.5312L48.474 75.4937L50.0638 76.4171C50.324 76.5637 50.5986 76.7396 50.8443 76.8569L51.538 77.238C52.5587 77.7427 53.6293 78.1358 54.732 78.4107L52.6942 81.0639Z"
        fill="#57A2FF"
      />
      <Path
        d="M68.5055 80.9027C66.9052 81.3536 65.2715 81.6722 63.6205 81.8555C61.9108 82.0268 60.1908 82.066 58.4753 81.9728L58.9378 79.0411C60.1956 79.1072 61.4565 79.0778 62.7099 78.9531C63.9168 78.8252 65.1109 78.5947 66.2797 78.2642L68.5055 80.9027Z"
        fill="#57A2FF"
      />
      <Path
        d="M78.2175 73.6318C77.2169 75.8797 75.502 77.7223 73.347 78.8649L69.8206 76.8127C71.3939 75.9762 72.6456 74.6292 73.3759 72.9868L78.2175 73.6318Z"
        fill="#57A2FF"
      />
      <Path
        d="M74.7056 64.5874C75.6937 65.3237 76.5702 66.2028 77.3071 67.1966C77.9085 68.0809 78.331 69.0773 78.55 70.1283L73.6361 70.4215C73.4715 69.6552 73.1623 68.9285 72.7256 68.2813C72.1828 67.5526 71.5405 66.906 70.8179 66.3611L74.7056 64.5874Z"
        fill="#57A2FF"
      />
      <Path
        d="M64.5453 58.5337L70.89 62.2423L67.4069 64.2945L61.0623 60.5712L64.5453 58.5337Z"
        fill="#7DB6FF"
      />
      <Path
        d="M54.5007 52.6553L60.8598 56.3639L57.3623 58.4014L51.0176 54.6928L54.5007 52.6553Z"
        fill="#7DB6FF"
      />
      <Path
        d="M48.2862 46.5137C48.4563 47.2806 48.7703 48.0073 49.2112 48.6539C49.7416 49.3843 50.3802 50.0271 51.1045 50.5594L47.2312 52.3478C46.2316 51.6144 45.3493 50.7294 44.6152 49.7239C44.009 48.8424 43.5861 47.8449 43.3723 46.7922L48.2862 46.5137Z"
        fill="#FF7270"
      />
      <Path
        d="M52.1017 40.1226C50.5298 40.947 49.2774 42.2844 48.5464 43.9191L43.7192 43.2741C44.7104 41.0247 46.4216 39.1807 48.5753 38.041L52.1017 40.1226Z"
        fill="#FF7270"
      />
      <Path
        d="M62.9846 37.8356C61.7268 37.7695 60.4659 37.7989 59.2124 37.9236C58.0108 38.062 56.8219 38.2973 55.6571 38.6272L53.4314 36.0326C55.0235 35.5677 56.6536 35.2488 58.3019 35.0798C60.0116 34.9112 61.7311 34.8671 63.4471 34.9479L62.9846 37.8356Z"
        fill="#FF4C4A"
      />
      <Path
        d="M73.477 41.4418L71.9016 40.5183C71.6415 40.3717 71.3524 40.1812 71.1212 40.0639L70.413 39.6974C69.3902 39.1942 68.3202 38.7965 67.219 38.5101L69.2424 35.8716C70.7362 36.2636 72.1885 36.8036 73.5781 37.484L74.532 37.997L75.3558 38.4661L76.9456 39.4043L73.477 41.4418Z"
        fill="#FF4C4A"
      />
      <Path
        d="M83.5217 47.3199L77.177 43.6113L80.6601 41.5591L87.0048 45.2824L83.5217 47.3199Z"
        fill="#FF4C4A"
      />
      <Path
        d="M93.5662 53.2125L87.207 49.4892L90.7046 47.4517L97.0493 51.1603L93.5662 53.2125Z"
        fill="#FF4C4A"
      />
      <Path
        d="M103.596 59.0904L97.2515 55.3671L100.749 53.3296L107.094 57.0382L103.596 59.0904Z"
        fill="#FF4C4A"
      />
      <Path
        d="M111.56 61.7586C110.148 62.4803 108.588 62.8562 107.007 62.8562C105.426 62.8562 103.867 62.4803 102.454 61.7586C99.9397 60.2927 99.9253 57.8887 102.454 56.4228C103.867 55.7011 105.426 55.3252 107.007 55.3252C108.588 55.3252 110.148 55.7011 111.56 56.4228C114.045 57.9034 114.06 60.2927 111.56 61.7586Z"
        fill="#FF4C4A"
      />
      <Path
        d="M18.774 59.6478C17.3638 60.3671 15.8072 60.7417 14.2287 60.7417C12.6502 60.7417 11.0936 60.3671 9.68333 59.6478C7.15413 58.1819 7.13968 55.7779 9.68333 54.3121C11.0915 53.586 12.649 53.2075 14.2287 53.2075C15.8084 53.2075 17.3658 53.586 18.774 54.3121C21.2743 55.7926 21.2888 58.1819 18.774 59.6478Z"
        fill="#57A2FF"
      />
      <Path
        d="M18.3837 8.24008C16.4326 7.4192 13.889 7.71237 11.1574 9.33947C5.0006 12.9455 0 21.682 0 28.85C0 38.6126 11.1574 49.7092 11.1574 49.7092L15.0018 51.732L22.3582 10.2923L18.3837 8.24008Z"
        fill="#7DB6FF"
      />
      <Path
        d="M14.9296 11.3625C21.0864 7.75648 26.087 10.6442 26.087 17.8123C26.087 27.5749 14.9296 51.7322 14.9296 51.7322C14.9296 51.7322 3.78662 40.6357 3.78662 30.8731C4.00116 26.9615 5.12195 23.1564 7.05802 19.7664C8.99409 16.3765 11.6909 13.4973 14.9296 11.3625Z"
        fill="#57A2FF"
      />
      <Path
        d="M8.46924 28.1316C8.46924 32.28 11.3598 33.995 14.9296 31.8548C16.8081 30.6204 18.3724 28.9532 19.4951 26.9892C20.6177 25.0252 21.267 22.8199 21.3899 20.5531C21.3899 16.4047 18.4993 14.6897 14.9296 16.8298C13.0511 18.0643 11.4867 19.7315 10.364 21.6955C9.24138 23.6595 8.59214 25.8648 8.46924 28.1316Z"
        fill="white"
      />
      <Path
        d="M4.10458 31.2248C4.10458 24.1447 9.04738 15.5108 15.1319 11.9488C20.4505 8.82654 24.873 10.6002 25.928 15.804C25.0609 10.1458 20.4794 8.12293 14.9296 11.4064C11.6909 13.5413 8.99409 16.4205 7.05802 19.8104C5.12195 23.2003 4.00116 27.0054 3.78662 30.917C3.78662 40.6796 14.9296 51.7761 14.9296 51.7761C13.5855 50.2663 4.10458 40.1812 4.10458 31.2248Z"
        fill="#96D2FF"
      />
      <Path
        d="M111.56 0.515245C109.291 -0.437562 106.328 -0.100422 103.09 1.79053C95.9508 5.98288 90.1553 16.1119 90.1553 24.438C90.1553 35.7691 103.09 48.654 103.09 48.654L106.949 50.5889L115.491 2.47949L111.56 0.515245Z"
        fill="#FF7270"
      />
      <Path
        d="M106.993 3.7398C114.147 -0.45255 120 2.90426 120 11.2303C120 22.5467 106.993 50.6032 106.993 50.6032C106.993 50.6032 93.9854 37.7184 93.9854 26.3873C94.0432 18.0612 99.8387 7.91749 106.993 3.7398Z"
        fill="#FF4C4A"
      />
      <Path
        d="M99.4917 23.1917C99.4917 28.0144 102.845 29.964 106.993 27.5893C109.174 26.1565 110.99 24.2213 112.293 21.9414C113.597 19.6615 114.351 17.1014 114.494 14.4699C114.494 9.64722 111.141 7.71229 106.993 10.0723C104.813 11.5068 102.998 13.4424 101.695 15.722C100.392 18.0015 99.6367 20.5607 99.4917 23.1917Z"
        fill="white"
      />
      <Path
        d="M94.6502 26.6221C94.6502 18.5013 100.301 8.59206 107.296 4.50232C114.291 0.412583 119.812 3.6228 119.928 11.5677C119.928 11.4505 119.928 11.3332 119.928 11.2306C119.928 2.90453 114.147 -0.496254 106.92 3.74007C99.6941 7.97639 93.9131 18.0615 93.9131 26.3876C93.9131 37.7186 106.92 50.6035 106.92 50.6035C106.92 50.6035 94.6502 37.6893 94.6502 26.6221Z"
        fill="#FF8685"
      />
    </Svg>
  );
}

export default LocationImage;
